import { ActionReducerMap } from '@ngrx/store';
import * as fromAuth from './authentication/reducers/auth.reducer';
import * as fromDocument from './documents/document.reducer';
import * as fromForm from './forms/forms.reducer';
import * as fromTables from './tables/table.reducer';
import * as fromLayout from './layout/reducers/layout.reducer';
import * as fromFeatureFlags from './feature-flags/feature-flags.reducer';
import * as fromConfig from './config/config.reducer';
import { DigiAIXCoreAppState } from './app-state';
import * as fromLoading from './loading/loading.reducer';
import * as fromLifeCycle from './life-cycle/life-cycle.reducer';
import * as fromWindow from './windows/window.reducer';

export const coreReducers: ActionReducerMap<DigiAIXCoreAppState['dx'], any> = {
  auth:         fromAuth.authReducer,
  documents:    fromDocument.firestoreDocumentReducer,
  forms:        fromForm.firestoreFormsReducer,
  tables:       fromTables.firestoreTableReducer,
  layout:       fromLayout.layoutReducer,
  featureFlags: fromFeatureFlags.featureFalgsReducer,
  config:       fromConfig.configReducer,
  loading:      fromLoading.reducer,
  lifeCycle:    fromLifeCycle.lifeCycleReducer,
  windows:      fromWindow.windowsReducer
};
